// extracted by mini-css-extract-plugin
export default {"button":"CompleteProjectForecastReportsButton_button__qgBcA","spinner":"CompleteProjectForecastReportsButton_spinner__4JQqw"};